import * as React from 'react';
import { cn } from '@/lib/utils';

const WidgetInstructionWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-widget-instruction-wrapper',
      // styles
      'flex flex-col gap-5',
      className
    )}
    {...props}
  />
));
WidgetInstructionWrapper.displayName = 'WidgetInstructionWrapper';

const WidgetInstruction = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-widget-instruction',
      // styles
      'flex items-center gap-10 rounded-xl bg-white p-5',
      className
    )}
    {...props}
  />
));
WidgetInstruction.displayName = 'WidgetInstruction';

const WidgetInstructionHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-widget-instruction-header',
      // styles
      'flex items-start gap-2',
      className
    )}
    {...props}
  />
));
WidgetInstructionHeader.displayName = 'WidgetInstructionHeader';

const WidgetInstructionNumber = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'c-widget-instruction-number',
      // styles
      'inline-block h-6 w-6 flex-shrink-0 rounded-full text-center align-middle',
      'text-base font-bold leading-6',
      'bg-[var(--color-neutral-lightest,#ECE9F8)] text-[var(--color-primary,#442B8C)]',
      className
    )}
    {...props}
  />
));
WidgetInstructionNumber.displayName = 'WidgetInstructionNumber';

const WidgetInstructionInfo = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-widget-instruction-info',
      // styles
      'flex-grow',
      className
    )}
    {...props}
  />
));
WidgetInstructionInfo.displayName = 'WidgetInstructionInfo';

const WidgetInstructionTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h4
    ref={ref}
    className={cn(
      'c-widget-instruction-title',
      // styles
      'mb-2 text-sm font-bold text-[var(--color-primary,#442B8C)]',
      className
    )}
    {...props}
  />
));
WidgetInstructionTitle.displayName = 'WidgetInstructionTitle';

const WidgetInstructionDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-widget-instruction-description',
      // styles
      'mb-0 text-sm font-light text-[var(--color-neutral-dark,#5D6A86)]',
      className
    )}
    {...props}
  />
));
WidgetInstructionDescription.displayName = 'WidgetInstructionDescription';

const WidgetInstructionBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-widget-instruction-body',
      // styles
      'text-center',
      className
    )}
    {...props}
  />
));
WidgetInstructionBody.displayName = 'WidgetInstructionBody';

const WidgetInstructionFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-widget-instruction-footer',
      // styles
      'mt-2 text-center',
      className
    )}
    {...props}
  />
));
WidgetInstructionFooter.displayName = 'WidgetInstructionFooter';

const WidgetInstructionImg = React.forwardRef(({ className, alt, ...props }, ref) => (
  <img
    ref={ref}
    alt={alt || ''}
    className={cn(
      'c-widget-instruction-img',
      // styles
      'h-[70px] w-auto max-w-fit',
      className
    )}
    {...props}
  />
));
WidgetInstructionImg.displayName = 'WidgetInstructionImg';

export {
  WidgetInstructionWrapper,
  WidgetInstruction,
  WidgetInstructionHeader,
  WidgetInstructionNumber,
  WidgetInstructionInfo,
  WidgetInstructionTitle,
  WidgetInstructionDescription,
  WidgetInstructionBody,
  WidgetInstructionFooter,
  WidgetInstructionImg
};
